import { get, isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import {
  CalculateAmortizationSchedule,
  payrollFrequencyMapper,
  usCurrency,
  usDateFormat,
} from "../../../../utils";
import { Link } from "react-router-dom";
import { SliderPanel } from "../../../../components";
import AmortizationSchedule from "../AmortizationSchedule/AmortizationSchedule";
import SourceWiseSplitUpSliderPanel from "../SourceWiseSplitUp/SourceWiseSplitUpSliderPanel/SourceWiseSplitUpSliderPanel";
import authService from "../../../../components/api-authorization/AuthorizeService";
const RequestSummary = ({
  principalPaid,
  currentData,
  updatedData,
  sourceSplit,
  loanStatus,
  sourceSplitData,
  calculateNetAmount,
  fromApproval,
}) => {
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [data, setData] = useState();
  const [silderType, setSliderType] = useState(null);
  const totalRequestedAmount = usCurrency(calculateNetAmount());
  const [userName, setUserName] = useState(null);

  let array = currentData.actualRepayments;

  var loanRemaningAmount = currentData["outstandingBalance"];
  var lastRepaymentEntryDate = new Date();
  var lastRepaymentEntry = !isEmpty(array) ? array[array.length - 1] : null;
  console.log("kiran lastRepaymentEntry", lastRepaymentEntry);
  var accuredInterest = 0.0;
  if (lastRepaymentEntry != null) {
    lastRepaymentEntryDate = new Date(lastRepaymentEntry.repaymentDate);

    const currentDate = new Date();

    if (currentDate > lastRepaymentEntryDate) {
      const diffTime = Math.abs(currentDate - lastRepaymentEntryDate);

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      accuredInterest =
        diffDays * (currentData.interestRate / 36500) * loanRemaningAmount;
    }
  } else {
    lastRepaymentEntryDate = new Date(currentData.loanActivationDate);

    const currentDate = new Date();

    if (currentDate > lastRepaymentEntryDate) {
      const diffTime = Math.abs(currentDate - lastRepaymentEntryDate);

      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      accuredInterest =
        diffDays * (currentData.interestRate / 36500) * loanRemaningAmount;
    }
  }

  const amortizationDataForTenureChange = CalculateAmortizationSchedule({
    frequency: payrollFrequencyMapper(
      get(updatedData, "repaymentFrequency", null)
    ),
    loanRequestAmout:
      currentData.requestedAmount +
      updatedData.loanRequestAmount +
      accuredInterest,
    interest: updatedData.interestRate,
    tenureYears: updatedData.tenureYears,
    tenureMonths: updatedData.tenureMonths,
    periodicPayment: 0,
    firstRepaymentDate: get(currentData, "firstRepaymentDate", null),
  });
  console.log("kiran use effect", amortizationDataForTenureChange);
  let noOfRemainingInstallments = 0;
  let noOfPassedInstallments = 1;
  amortizationDataForTenureChange.forEach((item) => {
    const date = new Date(item.firstRepaymentDate);
    const currentDate = new Date();
    if (date > currentDate) {
      noOfRemainingInstallments++;
    } else {
      noOfPassedInstallments++;
    }
  });
  const firstRepaymentDateOfUpdatedSchedule =
    amortizationDataForTenureChange[noOfPassedInstallments]?.firstRepaymentDate;

  console.log("Acured interest", accuredInterest, noOfRemainingInstallments);

  const loanData = [
    {
      loanTerms: "Loan Requested Amount",
      current: usCurrency(get(currentData, "requestedAmount", null)),
      updated: usCurrency(get(updatedData, "loanRequestAmount", null)),
    },
    {
      loanTerms: "Interest Rate",
      current: `${get(currentData, "interestRate", null)} %`,
      updated: `${get(updatedData, "interestRate", null)} %`,
    },
    {
      loanTerms: "Tenure Period",
      current: `${get(currentData, "tenureYears", null)}
      Years ${get(currentData, "tenureMonths", null)} Months`,
      updated: `${get(updatedData, "tenureYears", null)}
      Years ${get(updatedData, "tenureMonths", null)} Months`,
    },
    {
      loanTerms: "Repayment Frequency",
      current: payrollFrequencyMapper(
        get(currentData, "repaymentFrequency", null)
      ),
      updated: payrollFrequencyMapper(
        get(updatedData, "repaymentFrequency", null)
      ),
    },
    {
      loanTerms: "Outstanding Balance",
      current: usCurrency(
        get(currentData, "requestedAmount", null) - principalPaid
      ),
      updated: usCurrency(
        get(currentData, "requestedAmount", null) +
          get(updatedData, "loanRequestAmount", null) -
          principalPaid
      ),
    },
    {
      loanTerms: "Periodic Payment",
      current: usCurrency(get(currentData, "periodicPaymentAmount", null)),
      updated: usCurrency(get(updatedData, "periodicPayment", null)),
    },
    {
      loanTerms: "Amortization Schedule",
      current: currentData,
      updated: {
        ...updatedData,
        loanRequestAmount:
          currentData.requestedAmount +
          updatedData.loanRequestAmount +
          accuredInterest,
        firstRepaymentDate: firstRepaymentDateOfUpdatedSchedule,
      },
    },
    {
      loanTerms: "Source wise split-up",
      current: get(currentData, "sourceSplitup", []),
      updated: get(updatedData, "sourceSplitup", []),
    },
  ];

  return (
    <div className="mt-3 ml-3 mb-3" style={{ height: "40vh" }}>
      {fromApproval && (
        <h1 className="ft-14 fw-400 mb-3">
          Loan {updatedData?.modificationType == 1 ? "Reamortize" : "Refinance"}{" "}
          Request was raised by admin on{" "}
          {usDateFormat(updatedData?.requestedDate)}
        </h1>
      )}
      <div className="request-summary-container">
        <div className="d-flex ft-14 fw-500 req-summary-header w-100">
          <div className="p-20 w-35">Loan Terms</div>
          <div className="p-20 w-35">Current Loan Details</div>
          <div className="p-20 pl-5 w-30">Updated Loan Details</div>
        </div>
      </div>
      <>
        {loanData.map((data) => {
          return (
            <div className="req-summary-data">
              <div className="d-flex ft-14 fw-500 w-100">
                <div className="req-summary-content1 w-35">
                  {data.loanTerms}
                </div>
                {["Amortization Schedule", "Source wise split-up"].includes(
                  data.loanTerms
                ) ? (
                  <Link
                    className="req-summary-content1 w-35"
                    onClick={() => {
                      setData(data.current);
                      setSliderType(data.loanTerms);
                      setIsSliderOpen(true);
                    }}
                  >
                    View
                  </Link>
                ) : (
                  <div className="req-summary-content1 w-35">
                    {data.current}
                  </div>
                )}
                {["Amortization Schedule", "Source wise split-up"].includes(
                  data.loanTerms
                ) ? (
                  <Link
                    className="req-summary-content2 pl-5 w-30"
                    onClick={() => {
                      setData(data.updated);
                      setSliderType(data.loanTerms);
                      setIsSliderOpen(true);
                    }}
                  >
                    View
                  </Link>
                ) : (
                  <div className="req-summary-content2 pl-5 w-30">
                    {data.updated}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </>
      <SliderPanel
        isOpen={isSliderOpen}
        size="80"
        showCancel={true}
        backdropClicked={() => setIsSliderOpen(false)}
        showClose={true}
        onClose={() => setIsSliderOpen(false)}
      >
        {silderType == "Amortization Schedule" ? (
          <AmortizationSchedule
            loanStatus={loanStatus}
            loanData={data}
            hideDownload={true}
            requestSummary={true}
            noOfInstallments={noOfRemainingInstallments}
          />
        ) : (
          <SourceWiseSplitUpSliderPanel
            splitupOpen={isSliderOpen}
            setSplitupOpen={setIsSliderOpen}
            // values={data}
            values={currentData}
            overnightDelivery={
              data?.overnightDelivery ?? data?.overnightDelivery
            }
            sourceSplit={sourceSplitData}
            totalRequestedAmount={totalRequestedAmount}
          />
        )}
      </SliderPanel>
    </div>
  );
};

export default RequestSummary;
